import { render, staticRenderFns } from "./mallOrderDetails.vue?vue&type=template&id=21d8a912&scoped=true"
import script from "./mallOrderDetails.vue?vue&type=script&lang=js"
export * from "./mallOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./mallOrderDetails.vue?vue&type=style&index=0&id=21d8a912&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8a912",
  null
  
)

export default component.exports